import { mapGetters } from 'vuex';
import ediOrderItemService from './../../services/ediOrderItem';

export default {
  data() {
    return {
      ready: false,
    };
  },

  computed: {
    ...mapGetters({
      ediOrderItems: 'allEdiOrderItems',
    }),

    /**
     * Whether table should appear or not.
     */
    showTable() {
      if (this.ediOrderItems.length > 0) {
        return true;
      }

      return false;
    },
  },

  props: {
    /**
     * The current order.
     */
    order: {
      type: Object,
      required: true,
    },
  },

  methods: {
    getResources() {
      Promise.all([
        ediOrderItemService.all(this.order.ediOrderId),
      ]).then(() => {
        this.ready = true;
      });
    },
  },

  mounted() {
    this.getResources();
    return;
  },

  components: {
    VMessage: require('./../form/message/message.vue'),
  },
};



// WEBPACK FOOTER //
// ./src/app/components/originalOrderItems/originalOrderItems.js